// extracted by mini-css-extract-plugin
export default {"phoneInput":"phoneInput_phoneInput__LEn-H","select_element":"phoneInput_select_element__69Oi9"};